export default {
  "aor": {
       "action": {
          "add_filter": "添加过滤器",
          "back": "返回",
          "cancel": "取消",
          "close": "关闭",
          "create": "创建",
          "delete": "删除",
          "edit": "编辑",
          "list": "列表",
          "refresh": "刷新",
          "remove_filter": "移除过滤器",
          "save": "保存",
          "show": "展示"
        },
        "auth": {
          "avatar": "您的头像 URL（可选）",
          "bio": "简介（可选）",
          "education": "您的教育背景（可选）",
          "email": "邮箱",
          "first_name": "名（可选）",
          "last_name": "姓（可选）",
          "logged_in": "已登录",
          "logged_out": "已登出",
          "logging_in": "正在登录",
          "login": "登录",
          "logout": "登出",
          "name": "姓名",
          "password": "密码",
          "sign_in": "登录",
          "sign_in_error": "认证失败，请重试",
          "sign_up": "注册",
          "sign_up_error": "注册失败，请重试",
          "signing_up": "已注册",
          "username": "用户名",
          "website": "您的网站（可选）"
        },
        "boolean": {
          "false": "否",
          "true": "是"
        },
        "edit_profile": "编辑个人资料",
        "input": {
          "autocomplete": {
            "none": ""
          }
        },
        "message": {
          "about": "关于",
          "are_you_sure": "您确定吗？",
          "no": "否",
          "not_found": "您输入了错误的 URL，或者访问了错误的链接。",
          "yes": "是"
        },
        "navigation": {
          "next": "下一页",
          "no_more_results": "没有更多结果",
          "no_results": "未被修改：无历史记录可显示",
          "page_out_from_begin": "无法前往第一页之前",
          "page_out_from_end": "无法前往最后一页之后",
          "page_out_of_boundaries": "页码 %{page} 超出范围",
          "page_range_info": "%{offsetBegin}-%{offsetEnd} 共 %{total}",
          "prev": "上一页"
        },
        "notification": {
          "created": "创建成功",
          "deleted": "删除成功",
          "http_error": "服务器通信错误",
          "item_doesnt_exist": "元素不存在",
          "updated": "更新成功"
        },
        "page": {
          "create": "创建 %{name}",
          "dashboard": "控制面板",
          "delete": "删除 %{name} #%{id}",
          "edit": "%{name} #%{id}",
          "list": "%{name} 列表",
          "not_found": "未找到",
          "show": "%{name} #%{id}"
        },
        "profile_image": "头像",
        "validation": {
          "email": "必须是有效的邮箱地址",
          "maxLength": "最多 %{max} 个字符",
          "maxValue": "必须小于或等于 %{max}",
          "minLength": "至少 %{min} 个字符",
          "minValue": "必须大于或等于 %{min}",
          "number": "必须是数字",
          "required": "必填"
        }
      },
      "askQuestion": "提问",
      "auth": {
        "logged_in": "已登录",
        "logged_out": "已登出",
        "login": "登录",
        "logout": "登出",
        "sign_in": "登录",
        "sign_up": "注册"
      },
      "chartSunburst": {
        "breakdownTitle": "%{dontTranslate}主题的细分",
        "hoverClickItems": "悬停/点击项目",
        "switchChart": "切换图表"
      },
      "influence": {
        "year": "年份",
        "provinces": "省份",
        "populationTotal": "总人口",
        "populationShare": "人口占比"
      },
      "community": {
        "biographyShort": "简介",
        "board": "公告板",
        "highscore": "会员数据排行",
        "memberSince": "会员注册时间",
        "myProfile": "我的资料",
        "supportingMember": "赞助会员",
        "totalPoints": "总积分",
        "loginCount": "登录次数",
        "voteCount": "投票次数",
        "createCount": "创建次数",
        "editCount": "编辑次数",
        "deleteCount": "删除次数",
        "mistakesCount": "错误次数",
        "revertCount": "撤销次数",
        "linkedCount": "链接次数"
      },
      "didYouKnow": {
        "escape": "按Escape键可关闭打开的文章",
        "coloring": "可以通过菜单栏上的图层图标改变地图颜色为宗教、文化或人口",
        "discover": "可以点击菜单栏上的指南针图标浏览图片和其他媒体",
        "distribution": "可以点击文章中的圆形图表图标查看一个领域的人口分布完整情况",
        "link": "您可以在内容部分（文章）或媒体部分中链接任意文章",
        "markerlimit": "通过菜单栏上的图层图标减少标记符号数量可以提高性能",
        "province": "点击文章标题上的省份可以查看省份的完整历史",
        "question": "您可以在论坛中对文章提问并回答其他人的问题",
        "timeline": "您可以滚动时间轴进行缩放"
      },
      "introHints": {
        "step1": "滚动缩放并点击时间轴上的任意位置（1/3）",
        "step2": "打开图层菜单，并选择一些标记符号和重要事件（2/3）",
        "step3": "打开媒体菜单，浏览与选定年份相关的图片、视频等（3/3）",
        "stepFinal": "这些是基础介绍，还有众多功能等着您来探索。享受这段探索之旅吧！",
        "close": "关闭介绍"
      },
      "benchmarkPage": {
        "tier5Header": "无",
        "title": "默认设置",
        "tier1Header": "简洁",
        "tier1Description": "仅显示地图边界和标注",
        "tier2Header": "中等",
        "tier2Description": "显示边界、标注和每年至多2000个标记符号",
        "tier3Header": "完整",
        "tier3Description": "显示时间轴中的重要事件和每年至多5000个标记符号",
        "suggestion1": "根据您的机器规格，我们建议<b>%{dontTranslate}</b>",
        "suggestion2": "您的机器规格",
        "warning1": "虽然我们计划支持移动设备，但目前还未推出移动版本。敬请期待后续更新。",
        "warning2": "虽然我们计划支持平板电脑，但目前还不支持触控屏幕。敬请期待后续更新。",
        "continue": "继续",
        "specsTitle": "您的机器规格",
        "hint": "您可以稍后通过图层菜单自定义所有设置。"
      },
      "loadingPage": {
        "errorMessage": "Chronas目前负载较重，请稍等几分钟再试。",
        "loadingScreenDescription": {
          "218": "公元203-222年，年轻的罗马皇帝埃拉伽巴路斯举办宴会",
          "400": "霍诺留，狄奥多西一世之子；于公元393年由狄奥多西一世任命为西罗马帝国的首任皇帝。",
          "450": "450-511年：克洛维的孩子们的教育",
          "711": "711年：西哥特人的瓜达莱特战役及倭马亚王朝对西哥特王国征服的开始",
          "881": "881年：丹麦维京战士与加洛林王朝基督教军队的战役",
          "1121": "1121年：迪德格里战后，奥古斯托·费雷尔-达尔玛乌（Augusto Ferrer-Dalmau）绘",
          "1331": "1331年：大阪附近的赤坂之围是元弘之乱的早期战役之一",
          "1582": "1582年：楚瓦什海角战役",
          "1627": "1627-1628年：拉罗谢尔围城战（法兰西王国）",
          "1649": "1649年：克伦威尔在邓巴。奥利弗·克伦威尔统一了整个不列颠群岛，创立了英格兰联邦",
          "1832": "1832年：巴黎的新桥",
          "1862": "1862年：皇家前线之战中被俘的南方联盟囚犯",
          "1871": "1871年：德意志帝国在凡尔赛宣布成立",
          "-1400": "公元前1400年：雷鸣太阳战车，是在丹麦发现的北欧青铜时代的文物",
          "-2000": "公元前26世纪：乌尔皇家旗，一个上面有战争与和平场景的空心木盒",
          "-332": "公元前332年：亚历山大大帝征服巴比伦城",
          "-519": "公元前519年：辛辛纳图斯成为罗马共和国平民权利的反对者",
          "-52": "公元前52年：阿莱西亚战役后高卢酋长的投降",
          "-600": "公元前605-562年：新巴比伦帝国的迈步狮子（Striding Lion）",
          "-620": "公元前620-570年：萨福（Sappho）和阿尔卡埃乌斯（Alcaeus）",
          "-668": "公元前668年：亚述王国末代伟大国王亚述班拿巴勒狩猎狮子"
        }
      },
      "pos": {
        "about": "关于Chronas",
        "account": "管理账户",
        "addMedia": "添加媒体",
        "advanced": "高级",
        "area": "区域",
        "areas": "区域",
        "back": "返回",
        "basemap": "基础地图",
        "basemapTypes": {
          "none": "无",
          "topographic": "地形",
          "watercolor": "水彩"
        },
        "block": {
          "about1": "<h4>Chronas是什么?</h4><br /><h5>简介</h5>",
          "about2": "Chronas可以被认为是<a target='_blank' href='https://www.openstreetmap.org'>Open Street Map</a>、<a target='_blank' href='https://www.wikipedia.org/'>Wikipedia</a> 和 <a target='_blank' href='https://earth.google.com/web/'>Google Earth</a>的融合。它在地图上显示4000年来历史上的统治者（政治体）、文化和宗教，并链接到相关的Wikipedia文章，同时还有不同类型的标记符号，如人物、战役、城市、城堡等。它们都可以相互链接以表示彼此之间的关系（例如，城市的围攻战役可以链接到对应的城市标记）。此外，其他类型的媒体如视频、图片或播客也可以被链接，以创建更大的知识网络。用户可以对新的标记、区域或媒体项目进行评分、编辑和添加，并创建链接，所有这些都通过修订历史系统进行跟踪。用户们还可以在论坛中对文章提问，并创建关于重要主题（如战争或探索）的文章集合（所有区域都默认为重要目标）。您可以在这里找到展示这些功能的视频",
          "about3": "这里",
          "about4": "<h5>开始</h5><p>Chronas的名称是<b>Chron</b>os和Atl<b>as</b>的组合，表示时间和地图的结合。</p><p>2014年中期的最初想法是在类似Google Maps的应用程序中添加一个时间滑块，使其能够回到过去：观看王国的建立、成长和消失。目标是更好地理解世界历史是如何相互联系的。<i>当罗马统治欧洲时，亚洲发生了什么？当忽必烈在中国登基为帝时，阿拉伯发生了什么？</i></p><p>Chronas的原始版本发布于2015年，吸引了超过5000名注册用户。它基于<a target='_blank' href='https://umap.openstreetmap.fr/en'>Open Street Map</a>的一个分支，并使用了栅格地图库<a target='_blank' href='https://leafletjs.com/'>Leaflet</a>和关系型数据库<a target='_blank' href='https://www.postgresql.org/'>PostgreSQL</a>。</p><p>这里有一个约5分钟的视频，展示了原始版本的基本功能：</p>",
          "about5": "<p>如果您有兴趣尝试原始版本，它仍然可以在<a target='_blank' href='http://v0.chronas.org'>http://v0.chronas.org</a>上找到。它还包括了<a target='_blank' href='http://v0.chronas.org/blog'>开发博客</a>，详细解释了最初版本的技术，以及两个3D衍生应用，按维基百科语言展示<a target='_blank' href='http://app.chronas.org/castles/#/wikidata'>城堡</a>和<a target='_blank' href='http://app.chronas.org/battles/#/wikidata'>战役</a>。</p> <br /> <p>Chronas当前版本的开发始于2017年7月，完全重写了逻辑和架构，重点在于提高性能以及简化编辑、修订和链接相关文章。使用了WebGL地图库<a target='_blank' href='https://www.mapbox.com/mapbox-gl-js/api/'>Mapbox GL</a>替代Leaflet，以及使用<a target='_blank' href='https://reactjs.org/'>React JS</a>开发了用户界面。对于后端，使用了<a target='_blank' href='https://expressjs.com'>Express</a> <a target='_blank' href='https://nodejs.org/'>Node JS</a>编写的专用API，利用NoSQL <a target='_blank' href='https://nodejs.org/'>Mongo</a>数据库支持复杂查询和修订。</p> <p>您可以在<b>操作指南</b>部分找到新版Chronas的详细功能演示。</p>",
          "contact1": "开发者",
          "contact10": "发送",
          "contact2": "前端和后端开发",
          "contact3": "DevOps和开发支持",
          "contact4": "翻译者",
          "contact5": "联系方式",
          "contact6": "您可以直接发送电子邮件给我们（将鼠标悬停在电子邮件图标上以显示我们的电子邮件地址），或使用下面的表单：",
          "contact7": "您的电子邮件地址*",
          "contact8": "主题*",
          "contact9": "消息*",
          "howTo1": "如何在大约5分钟内学会使用",
          "howTo2": "如何在大约6分钟内学会编辑数据（附英文解说）",
          "pledge1": "您已使用Chronas上超过<b>15分钟啦</b>！",
          "pledge2": "Chronas的更新和维护依赖用户的支持。如果您想要支持Chronas，请访问",
          "pledge3": "给于任意金额的支持。",
          "pledge4": "赞助者们可以通过对功能优先级和主要设计决策的投票来引导项目的发展方向。",
          "pledge5": "如果您不想使用Patreon，也可以通过PayPal进行一次性捐助：",
          "rules1": "<br /> <h4>数据审编规则</h4> <ol>   <li><i>禁止恶意破坏</i>：这不是绘制虚构历史地图的地方。恶意破坏地图的行为会对项目造成巨大伤害（备份成本高昂）并将导致您被封禁。</li>   <li><i>观看教程视频</i>后再开始编辑。一些操作可能会导致<i>不想要的</i>结果。</li>   <li>您的数据输入应基于<i>公认的历史</i>，并且在被要求时应准备好引用来源。</li>   <li><i>请举报</i>违反这些规则的用户。</li> </ol> <br /> <h4>论坛规则</h4> <ol>   <li><i>禁止恶意破坏</i>：禁止种族歧视、偏见或冒犯行为。</li>   <li>提出<i>明确和具体的问题</i>，考虑<i>时间和地点</i>。</li>   <li>尽可能提供<i>一手和二手来源</i>，而不是<i>维基百科</i>等次级资料。</li>   <li>只允许提出严肃的、主题相关的问题：<i>禁止笑话</i>、<i>轶事</i>、<i>杂谈</i>或其他<i>离题</i>内容。</li>   <li><i>请举报</i>违反这些规则的回答。</li> </ol>",
          "statistics1": "以下统计数据是实时数据计数，来自当前Chronas数据库的快照",
          "statistics2": "地图数据点",
          "statistics3": "用户和参与度",
          "statistics4": "标记详情",
          "statistics5": "地图数据点",
          "statistics6": "详细信息",
          "statistics7": "媒体详情",
          "statistics8": "用户认证类型",
          "statisticsTooltip1": "区域数据点：2479个省份，4个维度上4000年的历史",
          "statisticsTooltip2": "标记包括人物和战役标记，但也包括城市等",
          "statisticsTooltip3": "媒体包括媒体（视频、图片等）以及重要事件（文章编集）",
          "statisticsTooltip4": "统治者、文化与宗教的独特地区实体总数",
          "statisticsTooltip5": "注册用户",
          "statisticsTooltip6": "用户对数据所做的编辑",
          "statisticsTooltip7": "论坛主题（包括自动生成和迁移的主题）",
          "statisticsTooltip8": "论坛评论（包括自动生成和迁移的回复）",
          "support1": "有几种方式来资助维护，开发新功能以及修复问题。例如，维基百科或公共电视台通过定期活动来筹集资金（<b>承诺活动（Pledge Drive）</b>），许多网络应用则使用<b>广告</b>（可能降低应用的可用性或用户体验）。另一种方式是引入<b>专业版本</b>或尝试吸引<b>风险投资</b>。",
          "support10": "开发者。",
          "support11": "如果您有兴趣在您的（或我们的）服务器上运行Chronas，并拥有一份完全控制的完整数据副本，",
          "support12": "联系",
          "support13": "我们，我们很乐意进一步讨论。",
          "support2": "我们选择了另一种融资方式，这种方式让那些支持Chronas的<b>长期用户</b>也有权决定其前进的方向。如果您认可我们的项目，请考虑通过",
          "support3": "支持我们，我们将在那里定期进行<b>投票</b>，以确定<b>新功能</b>以及<b>主要设计决策</b>的优先级。",
          "support4": "如果您不喜欢使用Patreon，也可以通过PayPal进行一次性捐款：",
          "support5": "新功能",
          "support6": "想要提出新的功能建议可以在功能建议",
          "support7": "论坛",
          "support8": "或直接",
          "support9": "联系",
          "welcome11": "<b>Chronas</b>是一款历史地图应用，拥有超过",
          "welcome12": "5000万个数据点",
          "welcome13": "，每位注册用户都可以进行内容编辑和贡献（就像<a>维基百科</a>一样）。",
          "welcome21": "在您开始之前，请先观看",
          "welcome22": "教程视频",
          "welcome23": "，位于“如何使用”部分。",
          "welcome31": "加入",
          "welcome32": "我们拥有<b>%{dontTranslate}</b>位会员的社区，以添加和编辑数据，赚取积分，询问有关历史文章的问题，并访问我们的",
          "welcome33": "论坛",
          "welcome34": "提出新的功能建议和报告错误。",
          "welcome41": "访问",
          "welcome42": "关于",
          "welcome43": "部分以了解更多关于Chronas项目的信息，并通过",
          "welcome44": "联系",
          "welcome45": "表单向开发者发送您的询问、评论或问题。",
          "welcome51": "我们相信这个项目有潜力成为与维基百科齐名的流行历史工具。如果您也对此充满热情并希望看到该项目成功，请考虑成为我们的长期支持者。有关<b>支持</b>和<b>Chronas的未来</b>的更多信息，请访问",
          "welcome52": "支持",
          "welcome53": "部分。"
        },
        "clusterMarker": "聚合标记",
        "community": "社区公告板",
        "configuration": "配置",
        "discover": "探索",
        "discover_component": {
          "seeMore1": "在",
          "seeMore2": "部分查看更多媒体...",
          "noFound": "未找到图片",
          "noGeotaggedFound": "在此位置未找到地理标记的图片，请查看探索部分以获取所有可用图片",
          "edit": "编辑此项",
          "hasNoArticle": "尚未链接维基百科文章，请考虑编辑此项",
          "hasNoSource": "尚未链接来源，请考虑编辑此项",
          "openArticle": "打开相关维基百科文章",
          "openSource": "在新标签页中打开",
          "tabs": {
            "HIGHLIGHTS": "亮点",
            "ARTEFACTS": "文物",
            "EPICS": "重要事件",
            "PEOPLE": "人物",
            "CITIES": "城市",
            "BATTLES": "战役",
            "OTHER": "其他",
            "VIDEOS": "视频",
            "PRIMARY SOURCES": "原始资料"
          }
        },
        "discover_label": "探索年份",
        "downvote": "不适当、错误或不准确",
        "edit": "编辑",
        "epicIdNameArray": {
          "ee": "探索",
          "ei": "发现",
          "eo": "其他重要事件",
          "es": "原始资料",
          "ew": "战争"
        },
        "epics": "重要事件",
        "migration": "迁移",
        "feedbackSuccess": "感谢您修正数据！",
        "flags": "报告为不准确数据",
        "flag": "标记为不准确数据",
        "unflag": "取消标记不准确数据",
        "filterMedia": "筛选媒体",
        "filter": "筛选",
        "fontType": "字体",
        "founded": "成立于",
        "fullscreenArticle": "全屏文章",
        "openArticleInNewTab": "在新标签页中打开文章",
        "general": "通用",
        "goFullScreen": "全屏",
        "goTutorial": "前往教程",
        "help": "介绍和信息",
        "images": "图片",
        "info": {
          "followUs": "关注我们",
          "lastDataEdit": "最后数据编辑",
          "tabs": {
            "about": "关于",
            "contact": "联系",
            "howTo": "操作指南",
            "rules": "规则",
            "statistics": "统计",
            "support": "支持",
            "welcome": "欢迎"
          },
          "welcomeTo": "欢迎使用"
        },
        "information": "信息",
        "label": "标注",
        "language": "语言",
        "layers": "图层",
        "linkedTypes": {
          "artefacts": "[图片] 文物",
          "audios": "[播客 & 音频]",
          "battles": "[图片] 战役",
          "cities": "[图片] 城市 & 建筑",
          "eb": "[重要事件] 传记",
          "ee": "[重要事件] 探险",
          "ei": "[重要事件] 发现",
          "eo": "[重要事件] 其他",
          "ew": "[重要事件] 战争",
          "h": "[HTML 或 文本]",
          "misc": "[图片] 其他",
          "o": "其他",
          "people": "[图片] 人物",
          "ps": "[链接] 原始资料",
          "v": "[视频]",
          "w|a": "[维基文章] 人物 -> 艺术家",
          "w|ar": "[维基文章] 文物",
          "w|at": "[维基文章] 人物 -> 运动员",
          "w|b": "[维基文章] 战役 -> 战役",
          "w|c": "[维基文章] 城市 -> 城市",
          "w|ca": "[维基文章] 城市 -> 城堡",
          "w|e": "[维基文章] 人物 -> 探险家",
          "w|l": "[维基文章] 其他 -> 地标",
          "w|m": "[维基文章] 人物 -> 军事人物",
          "w|o": "[维基文章] 其他 -> 未知",
          "w|op": "[维基文章] 人物 -> 未分类",
          "w|p": "[维基文章] 人物 -> 政治家",
          "w|r": "[维基文章] 人物 -> 宗教人物",
          "w|s": "[维基文章] 人物 -> 科学家",
          "w|si": "[维基文章] 战役 -> 围城"
        },
        "loading": "加载中...",
        "localeWikiNotFound": "未找到英文文章",
        "map": "地图",
        "markerIdNameArray": {
          "Artifact": "文物",
          "Artist": "艺术家",
          "Athlete": "运动员",
          "Battle": "战役",
          "Capital": "首都",
          "Castle": "城堡",
          "City": "城市",
          "Explorer": "探险家",
          "Landmark": "地标",
          "Military": "军事",
          "Politician": "政治家",
          "Religious": "宗教",
          "Scientist": "科学家",
          "Siege": "围城",
          "Unclassified": "未分类",
          "Unknown": "未知"
        },
        "markerLimit": "标记限制",
        "markerMetadataTypes": {
          "a": "艺术家",
          "ae|culture": "文化",
          "ae|religion": "宗教",
          "ae|religionGeneral": "宗教概况",
          "ae|ruler": "统治者",
          "ar": "文物",
          "at": "运动员",
          "b": "战役",
          "c": "城市",
          "ca": "城堡",
          "cp": "首都",
          "e": "探险家",
          "ee": "探索",
          "ei": "发现",
          "eo": "其他重要事件",
          "es": "原始资料",
          "ew": "战争",
          "l": "地标",
          "m": "军事",
          "o": "未知",
          "op": "未分类",
          "p": "政治家",
          "ps": "原始资料",
          "r": "宗教",
          "s": "科学家",
          "si": "围城"
        },
        "markers": "标记",
        "markersMedia": "标记和媒体",
        "markerType": "标记类型",
        "markerTypes": {
          "abstract": "抽象",
          "themed": "主题"
        },
        "markerCheckAll": "选择所有标记",
        "markerUncheckAll": "隐藏所有标记",
        "mediaTitle": "媒体：%{dontTranslate}",
        "metadata": "元数据",
        "migrationTooltip": "显示从出生地到死亡地的人口迁移路线，并按位置汇总。",
        "minimize": "最小化",
        "mod": "修改",
        "next": "下一个",
        "noLinkedContents": "目前还没有链接的媒体项目，请考虑添加并链接一个。",
        "opacityByPopulation": "透明度（人口）",
        "openArticle": "打开文章",
        "openEpic": "打开自己的重要事件",
        "openImage": "打开图片",
        "openSource": "打开来源",
        "partOf": "部分内容",
        "pledgeOpen": "在新标签页中打开Patreon",
        "pledgeRemind": "15分钟后提醒我",
        "pledgeTitle": "嘿，旅行者！",
        "pointsAdded": "您的账户已增加积分",
        "privacyPolicy": "隐私政策",
        "random": "随机文章",
        "readDocument": "阅读文档",
        "related_item": "相关项目...",
        "resources": "资源",
        "revisionHistory": "修订历史",
        "revisions": "修订",
        "allRevisions": "所有修订",
        "search": "搜索",
        "searchMarkers": "搜索标记",
        "setYearByArticle": "根据文章设置年份",
        "share": "分享链接或导出图片",
        "showProvinces": "显示省份",
        "signupToGatherPoints": "注册以获取您的贡献积分",
        "skipTutorial": "我知道我在做什么（跳过教程）",
        "startTyping": "开始输入",
        "statistics": {
          "area": "区域",
          "edits": "编辑",
          "entities": "实体",
          "markers": "标记",
          "media": "媒体",
          "replies": "回复",
          "threads": "主题",
          "users": "用户"
        },
        "termsofService": "服务条款",
        "theme": {
          "dark": "暗色",
          "font": "字体",
          "light": "亮色",
          "luther": "Concordia",
          "marker": "标记",
          "name": "主题"
        },
        "timeline": {
          "openAutoplayMenu": "打开自动播放菜单",
          "stopAutoplay": "停止自动播放",
          "autoplay": "自动播放",
          "autoplaySubtitle": "按步长更改年份",
          "stepSize": "步长（年）",
          "expand": "展开时间轴",
          "delay": "延迟（秒）",
          "repeat": "重复",
          "reset": "重置时间轴视图",
          "startSlideshow": "开始幻灯片放映",
          "searchEpics": "搜索重要事件"
        },
        "toggle": "切换",
        "upvote": "有趣且准确",
        "users": "管理用户",
        "welcome": "欢迎"
      },
      "resources": {
        "areas": {
          "fields": {
            "capital": "首都",
            "color": "区域颜色",
            "culture": "文化",
            "display_name": "显示名称",
            "endYear": "结束年份",
            "genReligion": "一般宗教",
            "icon_url": "图标（完整的commons.wikimedia或Wikipedia URL）",
            "key": "实体键",
            "main_religion_name": "主要宗教名称",
            "main_ruler_name": "主要统治者名称",
            "population": "人口",
            "province": "省份",
            "province_list": "点击省份以选择/取消选择",
            "religion": "宗教",
            "religionGen": "宗教概况",
            "replaceWith": "替换为",
            "ruler": "统治者",
            "search_name": "按名称选择",
            "startYear": "开始年份",
            "wiki_url": "文章（完整的Wikipedia URL）"
          }
        },
        "flags": {
          "fields": {
            "fixed": "已解决",
            "subEntityId": "子实体ID",
            "fullUrl": "完整URL",
            "wrongWiki": "错误的Wiki"
          }
        },
        "linked": {
          "fields": {
            "content": "描述",
            "description": "标题",
            "geojson": "地理信息（用于史诗）",
            "onlyEpicContent": "仅作为其他文章的链接部分使用（保存后将转到链接表单）",
            "poster": "海报图片链接",
            "source": "来源链接",
            "src": "来源链接/ID",
            "subtype": "类型",
            "wiki": "关联的Wikipedia文章",
            "year": "年份"
          }
        },
        "links": {
          "fields": {
            "content_list": "出现在左侧内容列表部分的项目",
            "media_list": "出现在媒体部分的项目",
            "source": "链接的原始文章"
          }
        },
        "markers": {
          "deleted": "标记已删除",
          "fields": {
            "capitalEnd": "结束年份",
            "capitalOwner": "统治者",
            "capitalStart": "开始年份",
            "coo": "坐标",
            "date": "日期",
            "endYear": "结束年份",
            "lastUpdated": "最后更新",
            "lat": "纬度",
            "lng": "经度",
            "name": "名称",
            "rating": "评分",
            "startYear": "开始年份",
            "subtype": "子类型",
            "type": "类型",
            "url": "URL",
            "year": "年份"
          },
          "name": "标记 |||| 标记",
          "place_marker": "放置标记",
          "tabs": {
            "reviews": "评论",
            "stats": "统计"
          }
        },
        "page": {
          "delete": "删除"
        },
        "revisions": {
          "fields": {
            "entityId": "实体ID",
            "id": "ID",
            "name": "名称",
            "nextBody": "下一内容",
            "prevBody": "前一内容",
            "resource": "资源",
            "reverted": "已撤销",
            "subtype": "子类型",
            "timestamp": "时间戳",
            "type": "类型",
            "user": "用户"
          },
          "name": "修订 |||| 修订"
        },
        "users": {
          "fields": {
            "createdAt": "创建于",
            "education": "教育",
            "email": "邮箱",
            "karma": "业力",
            "name": "名称",
            "privilege": "权限",
            "username": "用户名"
          },
          "name": "用户 |||| 用户",
          "page": {
            "delete": "删除账户"
          }
        }
      },
      "somethingWentWrong": "出现错误"
    }
